import React from "react";
import "./FormField.css";

interface FormFieldProps {
  label: string;
  htmlFor?: string;
  children: React.ReactNode;
  error?: string;
}

export function FormField({ label, htmlFor, children, error }: FormFieldProps) {
  return (
    <div className="protrain-form-field">
      <label className="protrain-form-label" htmlFor={htmlFor}>{label}</label>
      {children}
      {error && <span className="protrain-form-error">{error}</span>}
    </div>
  );
}

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger";
  children: React.ReactNode;
}

export function Button({ variant = "primary", children, ...props }: ButtonProps) {
  return (
    <button className={`protrain-btn protrain-btn--${variant}`} {...props}>
      {children}
    </button>
  );
}
